var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "archives-teacher" }, [
    _c("div", { staticClass: "yj-archives-query" }, [
      _c("header", { staticClass: "header wrapper" }, [
        _c(
          "div",
          { staticClass: "yj-query-r" },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "106px", "margin-right": "4px" },
                attrs: {
                  placeholder: "年级",
                  clearable: !!_vm.userInfo.isAdmin,
                  size: "mini",
                },
                on: {
                  change: function ($event) {
                    return _vm.handleCurrentChange(1)
                  },
                },
                model: {
                  value: _vm.gradeId,
                  callback: function ($$v) {
                    _vm.gradeId = $$v
                  },
                  expression: "gradeId",
                },
              },
              _vm._l(_vm.gradeList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.gradeName, value: item.id },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticStyle: { width: "106px", "margin-right": "4px" },
                attrs: { placeholder: "班级", clearable: "", size: "mini" },
                on: {
                  change: function ($event) {
                    return _vm.handleCurrentChange(1)
                  },
                },
                model: {
                  value: _vm.classId,
                  callback: function ($$v) {
                    _vm.classId = $$v
                  },
                  expression: "classId",
                },
              },
              _vm._l(_vm.classList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.className, value: item.id },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticStyle: { width: "106px", "margin-right": "4px" },
                attrs: { placeholder: "学科", clearable: "", size: "mini" },
                on: {
                  change: function ($event) {
                    return _vm.handleCurrentChange(1)
                  },
                },
                model: {
                  value: _vm.subjectCode,
                  callback: function ($$v) {
                    _vm.subjectCode = $$v
                  },
                  expression: "subjectCode",
                },
              },
              _vm._l(_vm.subjectList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.subjectName, value: item.subjectCode },
                })
              }),
              1
            ),
            _c("el-input", {
              staticStyle: { width: "120px", "margin-right": "4px" },
              attrs: { placeholder: "教师姓名", clearable: "", size: "mini" },
              model: {
                value: _vm.nickName,
                callback: function ($$v) {
                  _vm.nickName = $$v
                },
                expression: "nickName",
              },
            }),
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "mini",
                  plain: "",
                  loading: _vm.loading,
                },
                on: {
                  click: function ($event) {
                    return _vm.handleCurrentChange(1)
                  },
                },
              },
              [_vm._v(" 查询 ")]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "table-wrap wrapper" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { data: _vm.teacherList, size: "mini", border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "nickName", align: "center", label: "教师姓名" },
            }),
            _c("el-table-column", {
              attrs: { prop: "tel", align: "center", label: "手机号" },
            }),
            _c("el-table-column", {
              attrs: { align: "center", label: "学科" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(
                      scope.row.teacherRoleVos,
                      function (s, index) {
                        return _c("div", { key: index, staticClass: "cell" }, [
                          _vm._v(_vm._s(s.subjectName || "全部学科") + " "),
                        ])
                      }
                    )
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "className",
                align: "center",
                label: "当前年级/班级",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm._l(
                      scope.row.teacherRoleVos,
                      function (g, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "cell" },
                          [
                            g.gradeName
                              ? [
                                  _vm._v(" " + _vm._s(g.gradeName) + " "),
                                  g.className
                                    ? [
                                        _vm._v(
                                          " " + _vm._s(g.className) + "班 "
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : [_vm._v(" 全部年级 ")],
                          ],
                          2
                        )
                      }
                    )
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "studNumInClass",
                align: "center",
                label: "当前所带学生数",
              },
            }),
            _c("el-table-column", {
              attrs: { align: "center", label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", size: "normal" },
                          on: {
                            click: function ($event) {
                              return _vm.seeDetail(scope.row)
                            },
                          },
                        },
                        [_vm._v("查看档案")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("zj-pagination", {
              attrs: { page: { current: _vm.currentPage, total: _vm.total } },
              on: { "current-change": _vm.handleCurrentChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }